import { NgModule } from '@angular/core';
import { CommonModule as AngularCore } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { ComponentsModule } from '../../../components/components.module';
import { PipesModule } from '../../../pipes/pipes.module';
import { LearnLessonInfoModule } from '../lesson-info/learn-lesson-info.module';
import { LearnPlayerComponent } from './learn-player.component';

@NgModule({
  imports: [
    AngularCore,
    TranslateModule.forChild(),
    ComponentsModule,
    PipesModule,
    LearnLessonInfoModule,
    LearnPlayerComponent
  ],
  exports: [
    LearnPlayerComponent
  ]
})
export class LearnPlayerModule {
}

export {
  LearnPlayerComponent
};

